const headerData = [
	{
		label: '',
		prop: '',
		types: 'selection',
		columnwidth: '55'
	},
	{
		label: '产品线',
		prop: 'InvClassName',
		columnwidth: '100'
	},
	{
		label: '年份',
		prop: 'Year',
		columnwidth: '80'
	},
	{
		label: '年度指标',
		prop: 'YearQuota',
		columnwidth: '120'
	},
	{
		label: '1月指标',
		prop: 'JanQuota',
		columnwidth: '100'
	},
	{
		label: '2月指标',
		prop: 'FebQuota',
		columnwidth: '100'
	},
	{
		label: '3月指标',
		prop: 'MarQuota',
		columnwidth: '100'
	},
	{
		label: '4月指标',
		prop: 'AprQuota',
		columnwidth: '100'
	},
	{
		label: '5月指标',
		prop: 'MayQuota',
		columnwidth: '100'
	},
	{
		label: '6月指标',
		prop: 'JunQuota',
		columnwidth: '100'
	},
	{
		label: '7月指标',
		prop: 'JulQuota',
		columnwidth: '100'
	},
	{
		label: '8月指标',
		prop: 'AugQuota',
		columnwidth: '100'
	},
	{
		label: '9月指标',
		prop: 'SepQuota',
		columnwidth: '100'
	},
	{
		label: '10月指标',
		prop: 'OctQuota',
		columnwidth: '100'
	},
	{
		label: '11月指标',
		prop: 'NovQuota',
		columnwidth: '100'
	},
	{
		label: '12月指标',
		prop: 'DecQuota',
		columnwidth: '100'
	},
	{
		label: '创建人',
		prop: 'CreatorName',
		columnwidth: '120'
	},
	{
		label: '创建时间',
		prop: 'CreateTime',
		columnwidth: '160'
	}
]

export default headerData
